import { render, staticRenderFns } from "./Bakim.vue?vue&type=template&id=d63cd518&"
import script from "./Bakim.vue?vue&type=script&lang=js&"
export * from "./Bakim.vue?vue&type=script&lang=js&"
import style0 from "./Bakim.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports